import type {
  UseFormSetValue,
  UseFormGetValues,
  Control,
} from "react-hook-form";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/Endpoint";
import { classNames } from "../../utils/classNames";
import ComboboxFilter from "../Reusable/ComboboxFilter";
import DateRangePicker from "../Reusable/DateRangerPicker";
import MultiSelectFilter from "../Reusable/MultiSelectFilter";
import type { IFilterBranch } from "../../types/interface";

interface Props {
  setValue: UseFormSetValue<IFilterBranch>;
  getValues: UseFormGetValues<IFilterBranch>;
  control: Control<IFilterBranch, any>;
  isFilterVisible: boolean;
  handleFilterReset: () => void;
}

const BranchFilter = ({
  setValue,
  getValues,
  control,
  isFilterVisible,
  handleFilterReset: handleReset,
}: Props) => {
  return (
    <>
      <div
        className={classNames(
          isFilterVisible ? tw`block` : tw`hidden`,
          tw`relative`
        )}
      >
        {isFilterVisible ? (
          <div className={tw`grid md:grid-cols-4 gap-4`}>
            <DateRangePicker
              label={"Select Date Range"}
              setValue={setValue}
              name={"created__range"}
              getValues={getValues}
            />
            <ComboboxFilter<IFilterBranch>
              label={"From Branch"}
              placeholder={"Select Branch"}
              url={APIS.BRANCH}
              queryKey={"branch"}
              name={"pickup_branch"}
              params={{ is_active: true }}
              control={control}
            />
            <ComboboxFilter<IFilterBranch>
              label={"To Branch"}
              placeholder={"Select Branch"}
              url={APIS.BRANCH}
              queryKey={"branch"}
              name={"to_branch"}
              params={{ is_active: true }}
              control={control}
            />
            <MultiSelectFilter<IFilterBranch>
              label={"Status"}
              queryKey={"status__in"}
              params={{
                is_active: true,
              }}
              name={"status__in"}
              control={control}
              url={`${APIS.STATUS}`}
            />
            <button
              className={tw`absolute -top-5 right-5`}
              onClick={handleReset}
            >
              Reset
            </button>
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
};
export default BranchFilter;
